import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Shield, Clock, Timer, AlertTriangle } from 'lucide-react';
import { AdminSecuritySettings } from './AdminSecuritySettings';
import { TestClockSettings } from './TestClockSettings';
import { TestClockManager } from './TestClockManager';
import { DangerZone } from './DangerZone';

export function SystemManager() {
  return (
    <Tabs defaultValue="security" className="space-y-6">
      <div className="rounded-xl border border-border/60 bg-card p-1.5">
        <TabsList className="grid w-full grid-cols-2 md:grid-cols-4 h-auto bg-transparent gap-1 p-0">
          <TabsTrigger value="security" className="gap-2">
            <Shield className="h-4 w-4" />
            <span className="hidden sm:inline">Security</span>
          </TabsTrigger>
          <TabsTrigger value="test-clock" className="gap-2">
            <Clock className="h-4 w-4" />
            <span className="hidden sm:inline">Test Clock</span>
            <span className="sm:hidden">Clock</span>
          </TabsTrigger>
          <TabsTrigger value="test-clock-manager" className="gap-2">
            <Timer className="h-4 w-4" />
            <span className="hidden sm:inline">Clock Manager</span>
            <span className="sm:hidden">Manager</span>
          </TabsTrigger>
          <TabsTrigger
            value="danger"
            className="gap-2 text-destructive data-[state=active]:text-destructive"
          >
            <AlertTriangle className="h-4 w-4" />
            <span className="hidden sm:inline">Danger Zone</span>
            <span className="sm:hidden">Danger</span>
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="security" className="mt-0"><AdminSecuritySettings /></TabsContent>
      <TabsContent value="test-clock" className="mt-0"><TestClockSettings /></TabsContent>
      <TabsContent value="test-clock-manager" className="mt-0"><TestClockManager /></TabsContent>
      <TabsContent value="danger" className="mt-0"><DangerZone /></TabsContent>
    </Tabs>
  );
}
